<template>
    <v-layout justify-center>
        <v-responsive max-width="1440px" width="100%" height="100%">
            <v-row class="mt-8" justify="center" align="center">
                <v-col cols="auto" class="pt-0 pb-0 headline text-start">견적신청 목록</v-col>

                <v-spacer></v-spacer>

                <v-col cols="auto" class="pt-0 pb-0">
                    <v-btn class="ma-2" color="secondary" rounded @click="showSearch = !showSearch"><v-icon small class="mr-2">mdi-filter-variant</v-icon>검색필터</v-btn>
                </v-col>
            </v-row>

            <v-expand-transition>
                <v-card v-show="showSearch" class="elevation-1 mx-auto">
                    <v-card-title class="subtitle-2 font-weight-bold">검색필터</v-card-title>
                    <v-card-text class="py-0">
                        <v-row class="mt-6">
                            <v-col cols="12" sm="3" class="py-0">
                                <v-select v-model="filter.status" :items="statuses" item-text="text" item-value="value" dense hide-details label="견적신청상태" placeholder=" "></v-select>
                            </v-col>
                        </v-row>
                        <v-row class="mt-6">
                            <v-col cols="12" sm="3" class="py-0">
                                <v-select
                                    v-model="filter._category1"
                                    :items="categories1"
                                    item-text="name"
                                    item-value="_id"
                                    dense
                                    hide-details
                                    label="시공지유형"
                                    placeholder=" "
                                    @change="filter._category2 = null"
                                ></v-select>
                            </v-col>
                            <v-col cols="12" sm="3" class="py-0" v-if="filter._category1">
                                <v-select v-model="filter._category2" :items="categories2" item-text="name" item-value="_id" dense hide-details label="시공지유형상세" placeholder=" "></v-select>
                            </v-col>
                        </v-row>
                        <v-row class="mt-6">
                            <v-col cols="12" sm="3" class="py-0">
                                <v-select v-model="filter.searchKey" label="검색조건" placeholder=" " :items="searchKeyItems" dense hide-details></v-select>
                            </v-col>
                            <v-col cols="12" sm="3" class="py-0">
                                <v-text-field v-model="filter.searchValue" dense hide-details type="text" label="검색어" placeholder=" " @keydown="(e) => e.keyCode === 13 && search()" />
                            </v-col>
                        </v-row>
                    </v-card-text>
                    <v-card-actions>
                        <v-spacer></v-spacer>
                        <v-btn color="primary" rounded text @click="search"><v-icon small class="mt-1 mr-2">mdi-magnify</v-icon>검색</v-btn>
                    </v-card-actions>
                </v-card>
            </v-expand-transition>

            <v-row class="mt-4">
                <v-spacer></v-spacer>
                <v-col cols="auto">
                    <v-btn color="white" class="green--text px-2" @click="excel"
                        ><v-icon class="mr-2">{{ mdiMicrosoftExcel }}</v-icon
                        >엑셀다운로드</v-btn
                    >
                </v-col>
            </v-row>

            <v-data-table :headers="inquiriesHeaders" :items="inquiries" disable-sort disable-pagination hide-default-footer class="elevation-1">
                <template v-slot:item.createDate="{ item }">
                    <span v-if="item.createDate">{{ item.createDate.toDateTime() }}</span>
                    <span v-else>-</span>
                </template>
                <template v-slot:item.categoryParent="{ item }">
                    <span>{{
                        (() => {
                            return categories.find(({ _id }) => _id == item.category._parents[0]).name;
                        })()
                    }}</span>
                </template>
                <template v-slot:item.acreage="{ item }">
                    <span>{{ Number(item.acreage).format() + "평" }}</span>
                </template>
                <template v-slot:item.budget="{ item }">
                    <span>{{ formatBudget(item.budget) }}</span>
                </template>
                <!-- <template v-slot:item._user="{ item }">
                    <span v-if="item._user">회원</span>
                    <span v-else>비회원</span>
                </template> -->
                <template v-slot:item.phone="{ item }">
                    <span v-if="item.phone">{{ item.phone.phoneNumberFormat() }}</span>
                    <span v-else>-</span>
                </template>
                <template v-slot:item._estimates.length="{ item }">
                    {{ item._estimates.length ? item._estimates.length + "건" : "-" }}
                </template>
                <template v-slot:item.measurementInfo.measureAt="{ item }">
                    <span v-if="item.measurementInfo.measureAt">{{ item.measurementInfo.measureAt.toDateTime() }}</span>
                    <span v-else>-</span>
                </template>
                <template v-slot:item.actions="{ item }">
                    <v-icon small @click="edit(item)"> mdi-pencil </v-icon>
                </template>
            </v-data-table>

            <v-pagination v-model="page" :length="pageCount" :total-visible="11" class="mt-4 mb-12 mx-4" @input="search"></v-pagination>
        </v-responsive>
    </v-layout>
</template>

<script>
import XLSX from "xlsx";
import api from "@/api";

import { mdiMicrosoftExcel } from "@mdi/js";

export default {
    data() {
        return {
            mdiMicrosoftExcel,

            // filter related

            showSearch: true,
            filter: {
                status: this.$route.query.status || null,
                _category1: this.$route.query._category1 || null,
                _category2: this.$route.query._category2 || null,
                searchKey: this.$route.query.searchKey || null,
                searchValue: this.$route.query.searchValue || null,
                interiors: null,
            },
            searchKeyItems: [
                { text: ":: 전체 ::", value: null },
                { text: "사용자 이름", value: "name" },
                { text: "연락처", value: "phone" },
            ],
            statuses: [
                { text: ":: 전체 ::", value: null },
                { text: "견적신청", value: "견적신청" },
                { text: "실측완료", value: "실측완료" },
                { text: "계약완료", value: "계약완료" },
                { text: "취소", value: "취소" },
            ],

            categories: [],

            // pagination related

            page: +this.$route.query.page || 1,
            pageCount: 0,
            limit: 10,

            // data-table related
            inquiriesHeaders: [
                {
                    text: "견적신청일",
                    value: "createDate",
                    width: 120,
                    align: "center",
                },
                {
                    text: "시공지형태",
                    value: "categoryParent",
                    width: 100,
                    align: "center",
                },
                {
                    text: "시공지유형",
                    value: "category.name",
                    width: 100,
                    align: "center",
                },
                {
                    text: "시공면적",
                    value: "acreage",
                    width: 100,
                    align: "center",
                },
                {
                    text: "시공희망일",
                    value: "targetDate",
                    width: 100,
                    align: "center",
                },
                {
                    text: "시공예산",
                    value: "budget",
                    width: 140,
                    align: "center",
                },
                // {
                //     text: "신청유형",
                //     value: "_user",
                //     align: "center",
                // },
                {
                    text: "신청자",
                    value: "name",
                    width: 100,
                    align: "center",
                },
                {
                    text: "연락처",
                    value: "phone",
                    width: 140,
                    align: "center",
                },
                {
                    text: "견적신청상태",
                    value: "status",
                    width: 120,
                    align: "center",
                },
                {
                    text: "견적",
                    value: "_estimates.length",
                    width: 120,
                    align: "center",
                },
                {
                    text: "실측예정일",
                    value: "measurementInfo.measureAt",
                    width: 120,
                    align: "center",
                },
                {
                    text: "실측담당자",
                    value: "measurementInfo.measurer.name",
                    width: 100,
                    align: "center",
                },
                {
                    text: "Actions",
                    value: "actions",
                    // width: 100,
                    align: "center",
                },
            ],
            inquiries: [],
        };
    },
    created() {
        this.init();
    },
    methods: {
        async init() {
            try {
                const { categories } = await api.console.portfolios.categories.getCategories();

                this.categories = categories;

                await this.search(false);
            } catch (error) {
                console.error(error);
            }
        },
        async search(routable = true) {
            try {
                if (routable) {
                    this.$router.push({
                        query: Object.assignDefined({}, this.filter, {
                            page: this.page,
                        }),
                    });
                }

                if (this.isInterior) this.filter._interiors = this._user; // 인테리어 업체
                if (this.isMeasurer) this.filter["measurementInfo._measurer"] = this._user; // 실측기술자

                const { summary, inquiries } = await api.console.estimate.inquiries.getInquiries({
                    headers: {
                        skip: (this.page - 1) * this.limit,
                        limit: this.limit,
                    },
                    params: this.filter,
                });

                this.inquiries = inquiries;

                // 인테리어 업체
                if (this.isInterior) this.inquiriesHeaders = this.inquiriesHeaders.filter(({ value }) => value !== "_user" && value !== "name" && value !== "phone");

                this.pageCount = Math.ceil(summary.totalCount / this.limit);
            } catch (error) {
                console.error(error);
                if (error.response) alert(error.response.data.message);
                else alert(error.message.toString());
            }
        },
        async excel() {
            const { inquiries } = await api.console.estimate.inquiries.getInquiries({ params: this.filter });
            const data = inquiries.reduce(
                (array, inquiry) => [
                    ...array,
                    this.isInterior
                        ? {
                              견적신청일: inquiry.createDate.toDate(),
                              견적신청상태: inquiry.status,
                              "시공 유형": inquiry.category.name,
                              "시공 면적": Number(inquiry.acreage).format() + "평",
                              "시공 희망일": inquiry.targetDate,
                              "시공 예산": this.formatBudget(inquiry.budget),
                              "공사지 우편번호": inquiry.postcode,
                              "공사지 기본주소": inquiry.address1,
                              "공사지 상세주소": inquiry.address2,
                              요청사항: inquiry.requests,
                          }
                        : {
                              견적신청일: inquiry.createDate.toDate(),
                              견적신청상태: inquiry.status,
                              "시공 유형": inquiry.category.name,
                              "시공 면적": Number(inquiry.acreage).format() + "평",
                              "시공 희망일": inquiry.targetDate,
                              "시공 예산": this.formatBudget(inquiry.budget),
                              "공사지 우편번호": inquiry.postcode,
                              "공사지 기본주소": inquiry.address1,
                              "공사지 상세주소": inquiry.address2,
                              "신청자 성함": inquiry.name,
                              "신청자 연락처": inquiry.phone,
                              요청사항: inquiry.requests,
                              "사용자 성함": inquiry.user?.name,
                              "사용자 연락처": inquiry.user?.phone,
                              "사용자 이메일": inquiry.user?.email,
                              "사용자 우편번호": inquiry.user?.postcode,
                              "사용자 기본주소": inquiry.user?.address1,
                              "사용자 상세주소": inquiry.user?.address2,
                          },
                ],
                []
            );
            const workbook = new XLSX.utils.book_new();
            const worksheet = XLSX.utils.json_to_sheet(data);

            XLSX.utils.book_append_sheet(workbook, worksheet, "new");
            XLSX.writeFile(workbook, "견적신청목록.xlsx");
        },
        edit(inquiry) {
            this.$router.push({
                path: `${this.$route.path}/${inquiry._id}`,
            });
        },
        formatBudget(budget) {
            if (budget.includes("원") || budget.includes("미정")) return budget;
            else {
                budget = Number(budget);

                if (budget > 10000) return (budget / 10000).format() + "억" + (budget % 10000 ? ` ${(budget % 10000).format()}만원` : "");
                else return (budget % 10000).format() + "만원";
            }
        },
    },
    computed: {
        categories2() {
            const data = this.categories?.find(({ _id }) => _id == this.filter._category1)?.children || [];
            return data.length > 0 ? [{ name: ":: 전체 ::", _id: null }].concat(data) : [];
        },
        categories1() {
            return [{ name: ":: 전체 ::", _id: null }].concat(this.categories);
        },

        payload() {
            return this.$store.state.payload || {};
        },

        scope() {
            return this.payload.scope || [];
        },
        isInterior() {
            return this.scope.includes("interior");
        },
        isMeasurer() {
            return this.scope.includes("measurer");
        },

        _user() {
            return this.payload._user;
        },
    },
};
</script>
